import type { Observation, VisualFeature } from "../simulator/types";

export type ObjectKind = "traffic_light" | "stop_sign";
export type Box = [number, number, number, number]; // normalized x, y, width, height
export interface Detection { kind: ObjectKind; score: number; box: Box }
export interface ObjectTrack extends Detection {
    id: string; hits: number; firstSeenMs: number; lastSeenMs: number; confirmed: boolean;
}
export interface VisualEncounter {
    id: string; kind: ObjectKind; timestampMs: number; confidence: number; trackIds: string[];
    feature: VisualFeature;
}
export interface TrackerResult { tracks: ObjectTrack[]; encounters: VisualEncounter[] }
export interface DetectionResult {
    detections: Detection[]; inferenceMs: number; backend: string; tensorCount: number;
}
export interface VisionEvent extends VisualEncounter {
    observation: Observation; excluded: boolean;
}
export type DetectorCommand =
    | { type: "init"; origin: string }
    | { type: "detect"; pixels: ArrayBuffer; width: number; height: number; threshold: number };

export const OBJECT_LABELS: Record<ObjectKind, string> = { traffic_light: "Світлофор", stop_sign: "STOP · 2.2" };
